import { render } from "./PEarnbySharing.vue?vue&type=template&id=62b7262a&scoped=true"
import script from "./PEarnbySharing.vue?vue&type=script&lang=js"
export * from "./PEarnbySharing.vue?vue&type=script&lang=js"

import "./PEarnbySharing.vue?vue&type=style&index=0&id=62b7262a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b7262a"]])

export default __exports__